import React, { useState } from 'react';
import {
  Box,
  IconButton,
  Popover,
  Typography,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import useTranslation from '@/hooks/useTranslation'

const automaticDefinitions = [
  {
    labelKey: 'autoActionOkLabel',
    textKey: 'autoActionOkText',
  },
  {
    labelKey: 'autoActionNoFlowLabel',
    textKey: 'autoActionNoFlowText',
  },
  {
    labelKey: 'autoActionUnexpectedFlowLabel',
    textKey: 'autoActionUnexpectedFlowText',
  },
  {
    labelKey: 'autoActionFlowTooLowLabel',
    textKey: 'autoActionFlowTooLowText',
  },
  {
    labelKey: 'autoActionFlowTooHighLabel',
    textKey: 'autoActionFlowTooHighText',
  },
  {
    labelKey: 'autoActionResourceMissingLabel',
    textKey: 'autoActionResourceMissingText',
  },
  {
    labelKey: 'autoActionVerifyFlowLabel',
    textKey: 'autoActionVerifyFlowText',
  },
];

const AutoActionPopover: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const { t } = useTranslation()

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton size="small" onClick={handleClick}>
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: {
              maxWidth: 400,
              p: 2,
              backgroundColor: 'background.paper',
              boxShadow: 3,
            },
          },
        }}
      >
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          {t('autoActionFlowValveRequirement')}
        </Typography>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          {t('autoActionStateTitle')}
        </Typography>

        {automaticDefinitions.map(({ labelKey, textKey }, i) => (
          <Typography key={i} variant="body2" gutterBottom>
            <Typography
              component="span"
              variant="body2"
              fontWeight="bold"
              display="inline"
            >
               {t(labelKey)}:
            </Typography>{' '}
            {t(textKey)}
          </Typography>
        ))}
      </Popover>
    </>
  );
};

export default AutoActionPopover;
